import { render } from "./ProductDetailsContent.vue?vue&type=template&id=301b350c"
import script from "./ProductDetailsContent.vue?vue&type=script&lang=js"
export * from "./ProductDetailsContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lindelwankosinathi/Documents/projects/renaissancecs/node_modules/.pnpm/vue-loader@16.8.3_vue@3.2.39+webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__